import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Grid,
  Box,
  ThemeProvider,
} from "@mui/material";

import CHLogo from "assets/images/CH_logo.svg";
import { useAuth } from "../../hooks/useAuth";
import { QRCodeCanvas } from "qrcode.react";
import ViewBuyProduct from "components/Modal/Pawn/View/ViewBuyItems";
import moment from "moment";
import ReceiptHeader from "./ReceiptHeader";
import themeForm from "./ThemeForm";
import TableProductReceipt from "./TableProductReceipt";
import ReceiptFooter from "./ReceiptFooter";
import { formatCurrency2Digit } from "utils/helpers/format";

const InvoiceForm = ({ data, vat, detail, penaltys }) => {
  console.log("display new data ", data);
  console.log({ detail });
  const rowsPerPage = 9;
  const [currentDate, setCurrentDate] = useState(new Date());
  const [productData, setProductData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalRedeem, setTotalRedeem] = useState(0);
  const { user } = useAuth();
  const calculateTotalAmount = (products) => {
    return products.reduce((total, product) => {
      return (
        total +
        (parseFloat(product.price || 0) *
          parseFloat(product.total_amount || 1) || 0)
      );
    }, 0);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000); // Update every second

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (data) {
      console.log({ dataRedeem: data });
      const products = [];
      const productCount = Object.keys(data).reduce((max, key) => {
        const match = key.match(/_(\d+)$/);
        if (match) {
          const number = parseInt(match[1], 10);
          return Math.max(max, number);
        }
        return max;
      }, 0);

      for (let i = 1; i <= productCount; i++) {
        if (data[`product_name_${i}`] && data[`product_code_${i}`]) {
          // ตรวจสอบเฉพาะสินค้าที่มีชื่อและรหัส
          const product = {
            product_id: data[`product_id_${i}`],
            product_code: data[`product_code_${i}`],
            product_name: data[`product_name_${i}`],
            category_id: data[`category_id_${i}`],
            detail: data[`detail_${i}`],
            blemishes: data[`blemishes_${i}`],
            size: data[`size_${i}`],
            total_amount: data[`total_amount_${i}`],
            price: data[`price_${i}`],
            total_price: data[`total_price_${i}`],
            images: data[`images_${i}`],
            notes: data[`notes_${i}`],
            price_borrow_: data[`price_borrow_${i}`],
            total_amount_borrow: data[`total_amount_borrow_${i}`],
          };
          products.push(product);
        }
      }

      setProductData(products);
      setTotalRedeem(data?.total_price_redeem);
    }
  }, [data]);

  // Function to split the productData into boxes of rowsPerPage
  const splitIntoBoxes = (data, rowsPerPage) => {
    // หากมีข้อมูลที่ไม่ต้องการแบ่ง
    if (data.length <= rowsPerPage) {
      return [data]; // คืนข้อมูลทั้งหมดในกล่องเดียว
    }

    let boxes = [];
    for (let i = 0; i < data.length; i += rowsPerPage) {
      boxes.push(data.slice(i, i + rowsPerPage));
    }
    return boxes;
  };

  // Prepare the boxes using the filtered product data
  const boxes = splitIntoBoxes(productData, rowsPerPage);
  useEffect(() => {
    // ใช้ useEffect เพื่อคำนวณและอัพเดท totalAmount ทุกครั้งที่ boxes เปลี่ยนแปลง
    const newTotalAmount = boxes.reduce((total, boxData) => {
      console.log("total_price_order", boxData);
      return total + calculateTotalAmount(boxData);
    }, 0);

    setTotalAmount(newTotalAmount); // อัพเดท totalAmount ใน state
  }, [boxes]);

  const calculateFutureDate = (currentDate, totalDays) => {
    console.log("totalDays", totalDays);
    const futureDate = new Date(currentDate); // Clone the current date
    futureDate.setDate(futureDate.getDate() + totalDays); // Add total days
    return futureDate.toLocaleDateString(); // Convert to the desired date format
  };

  const formatReturnDateToBuddhist = (returnDate) => {
    const parsedDate = moment(returnDate, "DD/MM/YYYY เวลา HH:mm:ss น.");
    if (!parsedDate.isValid()) {
      console.error("Invalid date format:", returnDate);
      return "Invalid date";
    }

    // เพิ่ม 543 ปีเพื่อแปลงเป็น พ.ศ.
    const buddhistYear = parsedDate.year() + 543;

    // คืนค่าในรูปแบบ dd/MM/yyyy โดยใช้ปี พ.ศ.
    return parsedDate.format(`DD/MM/`) + buddhistYear;
  };

  return (
    <ThemeProvider theme={themeForm}>
      <Box
        sx={{
          mt: 2,
          transform: "scale(0.90)",
          transformOrigin: "top left", // จุดยึดอยู่มุมบนซ้าย
        }}
      >
        {boxes.map((boxData, boxIndex) => (
          <Box
            key={boxIndex}
            p={3}
            mb={2}
            border={1}
            bgcolor={"background.paper"}
            borderColor="grey.300"
            borderRadius={2}
            height={"559px"}
            width={"794px"}
            position="relative"
          >
            {/* Header Information */}
            <ReceiptHeader
              data={data}
              contracts={[
                { label: "สัญญาขายฝากเลขที่", value: detail?.order_code },
              ]}
            />

            {/* Table */}
            <TableProductReceipt
              columns={[
                { label: "รายการไถ่ถอน", key: "index" },
                {
                  label: "",
                  key: "product_name",
                  render: (_, product) => (
                    <>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          display: "flex",
                        }}
                      >
                        {product.product_name || "-"}
                      </Typography>
                      <Typography>
                        {product.detail ? `(${product.detail})` : "-"}
                      </Typography>
                    </>
                  ),
                },

                { label: "รหัส1", key: "product_code" },
                { label: "รหัส2", key: "product_code_com" },
                {
                  label: "ราคา/ต่อหน่วย",
                  key: "price",
                },
                { label: "จำนวน", key: "total_amount" },
                { label: "ส่วนลด", key: "promotions" },
                {
                  label: "มูลค่ารวม",
                  key: "total_price",
                  // Custom render function to calculate total sell price
                  render: (_, product) => (
                    <Typography sx={{ fontWeight: "bold" }}>
                      {(
                        parseFloat(product.price || 0) *
                          parseFloat(product.total_amount || 1) -
                        parseFloat(product.promotions ?? 0)
                      ).toLocaleString() + " บาท"}
                    </Typography>
                  ),
                },
              ]}
              products={boxData}
            />

            {/* Box count display (e.g., "1/3", "2/3") */}
            <ReceiptFooter index={boxIndex} length={boxes?.length} />
          </Box>
        ))}
        <Box
          p={3}
          mb={2}
          border={1}
          bgcolor={"background.paper"}
          borderColor="grey.300"
          borderRadius={2}
          height={"559px"}
          width={"794px"}
          position={"relative"}
        >
          <ReceiptHeader
            data={data}
            contracts={[
              { label: "สัญญาขายฝากเลขที่", value: detail?.order_code ?? "-" },
            ]}
          />
          <Grid container mt={2}>
            {/* Payment Information */}
            <Grid container xs={12} sx={{ mt: 4 }}>
              <Grid
                item
                xs={6}
                container
                justifyContent="center"
                alignItems={"start"}
              >
                <Typography align="center">
                  ชำระเงินโดย :{" "}
                  {data?.payment_channel ? data.payment_channel.id : "เงินสด"}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Grid container justifyContent="flex-end">
                  {/* <Grid item xs={6}>
                    <Typography align="right">อัตราดอกเบี้ยร้อยละ</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography align="right">
                      {detail?.interest_rate}%
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography align="right">ดอกเบี้ย/เดือน</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography align="right">
                      {formatCurrency2Digit(
                        detail?.pawn_price * (detail?.interest_rate / 100)
                      )}{" "}
                      บาท
                    </Typography>
                  </Grid> */}
                  <Grid item xs={6}>
                    <Typography align="right">ดอกเบี้ย ณ วันไถ่ถอน</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography align="right">
                      {formatCurrency2Digit(data?.interest_amount || 0)} บาท
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography align="right">ราคาไถ่ถอนตามสัญญา</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography align="right">
                      {formatCurrency2Digit(parseFloat(totalRedeem) || 0)} บาท
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography align="right">ราคาขายฝาก</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography align="right">
                      {formatCurrency2Digit(totalAmount)} บาท
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography align="right">ส่วนต่าง/ค่าปรับ</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography align="right">
                      {formatCurrency2Digit(data?.penaltys)} บาท
                    </Typography>
                  </Grid>
                  {vat ? (
                    <Grid container justifyContent="flex-end">
                      <Grid item xs={6}>
                        <Typography align="right">Vat (7%)</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography align="right">
                          {formatCurrency2Digit(
                            (parseFloat(totalAmount) +
                              parseFloat(data?.penaltys)) *
                              0.07
                          )}{" "}
                          บาท
                        </Typography>
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>

            {/* Summary Information */}
            <Grid
              container
              xs={12}
              sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}
            >
              <Grid item xs={6}>
                <Grid container justifyContent="flex-end">
                  <Grid item xs={6}>
                    <Typography align="right" style={{ fontWeight: "bold" }}>
                      รวมจำนวนเงินรายการไถ่ถอนทั้งสิ้น
                    </Typography>
                  </Grid>
                  {vat ? (
                    <Grid item xs={6}>
                      <Typography align="right" style={{ fontWeight: "bold" }}>
                        {formatCurrency2Digit(
                          (parseFloat(totalRedeem) +
                            parseFloat(data?.penaltys)) *
                            0.07 +
                            (parseFloat(totalRedeem) +
                              parseFloat(data?.penaltys))
                        )}{" "}
                        บาท
                      </Typography>
                    </Grid>
                  ) : (
                    <Grid item xs={6}>
                      <Typography
                        align="right"
                        style={{ fontSize: "10px", fontWeight: "bold" }}
                      >
                        {formatCurrency2Digit(
                          parseFloat(totalRedeem) +
                            parseFloat(data?.penaltys || 0)
                        )}{" "}
                        บาท
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>

            {/* Footer */}
            <Box
              sx={{
                mt: 6,
                border: "1px solid #00BB9F",
                borderRadius: "12px",
                width: "100%",
              }}
            >
              <Grid container sx={{ height: "100%" }}>
                {/* Column 1 */}
                <Grid
                  item
                  xs={4}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "1px solid #00BB9F",
                    padding: "10px",
                  }}
                >
                  {/* Top Divider Line */}
                  <Box
                    sx={{
                      width: "100%",
                      borderTop: "1px solid #B0B0B0",
                      mb: 1,
                      mt: 5,
                    }}
                  />
                  <Typography align="center" style={{ fontSize: "12px" }}>
                    ผู้ไถ่ถอน
                  </Typography>
                  <Typography align="center">
                    {currentDate.toLocaleDateString()}
                  </Typography>
                </Grid>

                {/* Column 2 */}
                <Grid
                  item
                  xs={4}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRight: "1px solid #00BB9F",
                    padding: "10px",
                    height: "100%", // Ensure the column takes full height
                  }}
                >
                  {/* Top Divider Line */}
                  <Box
                    sx={{
                      width: "100%",
                      borderTop: "1px solid #B0B0B0",
                      mb: 1,
                      mt: 5,
                    }}
                  />
                  <Typography align="center" style={{ fontSize: "12px" }}>
                    ผู้รับฝาก
                  </Typography>
                  <Typography align="center">
                    {currentDate.toLocaleDateString()}
                  </Typography>
                </Grid>

                {/* Column 3 */}
                <Grid
                  item
                  xs={4}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                    height: "100%", // Ensure the column takes full height
                  }}
                >
                  {/* Top Divider Line */}
                  <Box
                    sx={{
                      width: "100%",
                      borderTop: "1px solid #B0B0B0",
                      mb: 1,
                      mt: 5,
                    }}
                  />
                  <Typography align="center" style={{ fontSize: "12px" }}>
                    ผู้อนุมัติ
                  </Typography>
                  <Typography align="center">
                    {currentDate.toLocaleDateString()}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Box count display (e.g., "1/3", "2/3") */}
          <ReceiptFooter index={boxes?.length} length={boxes?.length} />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default InvoiceForm;
